<ion-list>
  <ion-item button lines="none" (click)="openGoogleDrivePicker()">
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path id="Path" d="M8.33331 3H15.6666L23 15H15.6666L8.33331 3Z" fill="#FFC107"></path>
      <path id="Path_2" d="M4.6012 21L8.30086 15H23L19.3333 21H4.6012Z" fill="#1976D2"></path>
      <path id="Path_3" d="M1 15.0625L4.60119 21L12 9L8.33333 3L1 15.0625Z" fill="#4CAF50"></path>
    </svg>
    Desde Google Drive
  </ion-item>
  <ion-item *ngIf="isDropboxSupported()" button lines="none" (click)="openDropboxPicker()">
    <svg viewBox="0 0 64 64" role="presentation">
      <path
        d="M25.1797 13L13.8369 20.125L25.1797 27.25L36.5244 20.125L47.8672 27.25L59.21 20.125L47.8672 13L36.5244 20.125L25.1797 13Z"
        fill="#0061fe"
      ></path>
      <path d="M25.1797 41.5001L13.8369 34.3751L25.1797 27.25L36.5244 34.3751L25.1797 41.5001Z" fill="#0061fe"></path>
      <path d="M36.5244 34.3751L47.8672 27.25L59.21 34.3751L47.8672 41.5001L36.5244 34.3751Z" fill="#0061fe"></path>
      <path d="M36.5245 51L25.1797 43.875L36.5245 36.75L47.8672 43.875L36.5245 51Z" fill="#0061fe"></path>
    </svg>
    Desde Dropbox
  </ion-item>
</ion-list>
